<mat-card class="role-list-card">
  <h2>Career Roles</h2>
  <form [formGroup]="form" class="form-grid">
    <mat-form-field appearance="outline">
      <mat-label>Search</mat-label>
      <input matInput formControlName="searchText" placeholder="Role name" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Page</mat-label>
      <input matInput type="number" formControlName="page" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Page Size</mat-label>
      <input matInput type="number" formControlName="pageSize" />
    </mat-form-field>
    <mat-checkbox formControlName="activeOnly">Show active roles only</mat-checkbox>
    <button mat-flat-button type="button" (click)="submit()" [disabled]="form.invalid || loading">
      Load Roles
    </button>
  </form>
  <p class="meta" *ngIf="items.length">Total roles: {{ totalCount }}</p>
  <div class="role-list" *ngIf="items.length">
    <article
      class="role-item"
      *ngFor="let role of items"
      [class.compact]="compact"
      [class.clickable]="compact"
      (click)="compact && onOpenRole(role.roleSlug)">
      <header class="role-header">
        <div>
          <h3>{{ role.roleName }}</h3>
          <p>{{ role.roleSlug }} | {{ role.industry }}</p>
        </div>
        <mat-chip *ngIf="compact" [highlighted]="isEngaged(role.activationStatus, role.active)">
          {{ activationStatusLabel(role.activationStatus, role.active) }}
        </mat-chip>
      </header>
      <p class="summary">{{ role.summary }}</p>
      <p class="meta"><strong>Status:</strong> {{ activationStatusLabel(role.activationStatus, role.active) }}</p>
      <div class="accounts" *ngIf="role.effectiveAllowedAccounts?.length">
        <span class="accounts-label">Accounts:</span>
        <mat-chip-set>
          <mat-chip *ngFor="let account of role.effectiveAllowedAccounts" [matTooltip]="account.slug">
            {{ account.name }}
          </mat-chip>
        </mat-chip-set>
      </div>
      <p class="meta" *ngIf="!role.effectiveAllowedAccounts?.length"><strong>Accounts:</strong> None</p>
      <p class="compact-meta">
        Core skills: {{ role.coreSkillCount }} ·
        Specializations: {{ role.specializationCount }}
      </p>
    </article>
  </div>
</mat-card>
